import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Typography } from "@material-ui/core";
import { auth } from "../config/firebase";
import Alert from "../components/alert";
import Toast from "../components/MessageToast";

export default class AuthProvider extends Component {
  state = {
    loading: true,
  };
  componentDidMount() {
    this.onAuthChange = auth.onAuthStateChanged(async (currentUser) => {
      if (currentUser) {
        try {
          const userData = await currentUser.getIdTokenResult(true);
          localStorage.setItem(
            "au",
            JSON.stringify({
              displayName: currentUser.displayName,
              email: currentUser.email,
              photo: currentUser.photoURL,
              claims: {
                ...userData.claims,
                aud: undefined,
                auth_time: undefined,
                email: undefined,
                email_verified: undefined,
                exp: undefined,
                firebase: undefined,
                iat: undefined,
                iss: undefined,
                picture: undefined,
                sub: undefined,
                user_id: undefined,
                name: undefined,
                apps: undefined,
                organizations: undefined,
              },
              aut: userData.token,
            })
          );
          this.setState({ loading: false });
        } catch (error) {
          console.log(error);
          this.setState({ loading: false });
          if (error.code.includes("network-request-failed")) {
            Toast({
              message: error.message,
              type: "error",
            });
          }
        }
      } else {
        localStorage.removeItem("au");
        window.location.assign(
          `/login?redUrl=${window.location.protocol}//${window.location.host}${window.location.pathname}`
        );
      }
    });

    // Keeps the cached token in sync whenever the SDK refreshes it -
    // proactively before its real expiry, not on a fixed timer that can
    // fall behind while the tab is backgrounded. Sign-in/out are already
    // handled above by onAuthStateChanged, so only update the cached
    // token here (mirrors what the interval this replaces used to do).
    this.onIdTokenChange = auth.onIdTokenChanged(async (currentUser) => {
      if (!currentUser) return;
      const stored = localStorage.getItem("au");
      if (!stored) return;
      const token = await currentUser.getIdToken();
      const parsedUser = JSON.parse(stored);
      parsedUser.aut = token;
      localStorage.setItem("au", JSON.stringify(parsedUser));
    });
  }

  componentWillUnmount() {
    this.onAuthChange();
    this.onIdTokenChange();
  }
  render() {
    return (
      <div>
        {this.state.loading ? (
          <Box padding={2}>
            <Grid
              container
              justify="center"
              alignItems="center"
              direction="column"
              style={{ margin: "42vh 0" }}
            >
              <CircularProgress />
              <Typography align="center">
                Dear user, please wait a moment...
              </Typography>
            </Grid>
          </Box>
        ) : this.state.error ? (
          <Box padding={2}>
            <Grid
              container
              justify="center"
              alignItems="center"
              direction="column"
              style={{ margin: "42vh 0" }}
            >
              <Alert title={this.state.error} type="warning" />
            </Grid>
          </Box>
        ) : (
          this.props.children
        )}
      </div>
    );
  }
}
